<template lang="pug">
.login--content
  .content__left
    .middle
      h1.title.is-1 Bienvenido
      h2.subtitle.is-2 al gestor de cotizaciones
      .benefits__text
        span Con este sistema podrás:
        ul
          li Crear una cotización
          li Seguir una cotización
  .content__right
    .middle
      form(@submit.prevent="onSubmit")
        .logo
          img(src="../assets/images/logo-orange.svg")
        h2.title-login Iniciar sesión
        b-field(label="Usuario" :type="{'is-danger': errors.has('username')}")
          b-input(type="text" name="username" size="is-medium" v-model="formData.username" autocomplete="off" v-validate="'required|min:2'" placeholder="Ingresa tu usuario")

        b-field(label="Contraseña" :type="{'is-danger': errors.has('password')}")
          b-input(type="password" name="password" size="is-medium" v-model="formData.password" autocomplete="off" password-reveal v-validate="'required'")
        div.error-login(v-if="showError") El usuario o contraseña son incorrectos
        .forgot-password-wrapper
          a.forgot-password(@click="showForgotPassword") Olvidé mi contraseña
        .field.big-margin.center.buttons-login-wrapper
          button.button.button-margin Ingresar
    vue-recaptcha(
      ref="recaptcha"
      size="invisible"
      sitekey="6Lc8EGshAAAAAInSlYRmHIe3VHTwYUyWroKxYyqh"
      @verify="onVerify"
      @error="errorMethod"
      @render="renderMethod"
    )
    modal-denied-access
    modal-attemps-exceed
    modal-update-password
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';
import Auth from '@/mixins/auth'
import {RepositoryFactory} from '@/services/RepositoryFactory'
import ModalDeniedAccess from './modals/DeniedDirectAccess'
import ModalAttempsExceed from './modals/AttemptsExceed.vue'
import ModalUpdatePassword from './modals/UpdatePassword.vue'
const AuthRepository = RepositoryFactory.get('auth')

export default {
  components: {
    ModalDeniedAccess,
    ModalAttempsExceed,
    ModalUpdatePassword,
    VueRecaptcha
  },
  data () {
    return {
      formData: {
        username: null,
        password: null,
        isCardModalActive: true,
      },
      widgetID: null,
      showError: false
    }
  },
  methods: {
    onVerify(response) {
      console.log('Verify Captcha 2: ' + response)
    },
    errorMethod() {
      Auth.removeSession()
      this.$store.commit('setAuth', null);
      this.$router.push('/');
    },
    renderMethod(id) {
      this.widgetID = id
      this.$refs.recaptcha.reset(id);
    },
    onSubmit() {
      const loader = this.$buefy.loading.open();
      this.$validator.validateAll().then(valid => {
        if (valid) {
          AuthRepository.login(this.formData)
          .then(result => {
            this.showError = false
            loader.close()
            if (result.data.user.password_change_required){
              this.$store.commit('setAuth', result.data);
              Auth.setSession(result.data)
              this.$router.push('/actualizar-contrasena')
            } else if (result.data.user.direct_login_access == false) {
              this.$modal.show('modal-denied-access');
            } else if ( result.data.user.direct_login_access ) {
              this.$store.commit('setAuth', result.data);
              Auth.setSession(result.data)
              this.$router.push('/dashboard')
            }
          })
          .catch(error => {
            loader.close()
            this.showError = true
            this.errors.add({
              field: 'username',
              msg: 'error'
            })
            this.errors.add({
              field: 'password',
              msg:'error'
            })
            if(error.response.status === 403 && error.response.data.error_code === "attempts_exceeded") {
              this.showError = false
              this.$modal.show('modal-attemps-exceed');
            } else if (error.response.status === 403 && error.response.data.error_code === "password_expired") {
              this.showError = false
              this.$modal.show('modal-update-password');
            }
            
          })
        }
      }).catch(e => {
        console.log(e)
      })
    },

    showForgotPassword() {
      this.$router.push('/forgot-password')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/mixins";

.login--content {
  display: flex;
  height: 100vh;
  padding: 32px 22px;
  box-sizing: border-box;
  .content__left {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    background-image: url('../assets/images/login-background.jpg');
    background-color: white;
    width: 100%;
    max-width: 960px;
    background-repeat: no-repeat;
    background-position: left top;
    background-size: cover;
    text-align: left;
    border-radius: 16px;

    @include desktop {
      display: flex;
    }
    .middle {
      width: 100%;
      max-width: 580px;
      margin-right: 2.5em;
      display: none;
      h1 {
        color: white;
        font-weight: 100;
      }
      h2 {
        color: white;
        font-weight: 100;
      }

      .benefits__text{
        margin-top: 3.5em;
        color: white;

        span{
          display: block;
          font-weight: bold;
          font-size: 1.5em;
          margin-bottom: 1em;
        }

        ul{
          margin-left: 1.3em;

          li {
            font-weight: 100;
            font-size: 1.5em;
            list-style-type: disc;
          }
        }
      }
    }
  }

  .content__right {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .middle {
      width: 360px;
      margin: 0 auto;

      form {
        display: flex;
        flex-direction: column;
      }
      .logo{
        margin-bottom: 0;
        text-align: center;
        img{
          width: 50%;
          margin: 0 auto;
        }
      }
      .help__text{
        color: #ABABAB;
        text-align: center;
        font-size: 1em;
      }
      .error-login {
        color: #FF6D46;
        display: flex;
        justify-content: center;
      }
      .field{
        margin-bottom: 2em;
        text-align: left;
        &.big-margin{
          margin-top: 3em;
          margin-bottom: 0;
        }

        span{
          font-size: 1.375em;
          color: #878787;
          font-weight: 100;
        }

        input {
          width: 100%;
          max-width: 320px;
          padding: 0.5em 0;
          border: none;
          border-bottom: 1px solid #ABABAB;
          font-family: 'mirai-bold_font';
          color: #595959;
          font-size: 1.375em;

          &.field__error{
            border-bottom: 1px solid #FF6D46;
          }
        }

        .button {
          color: white;
          border-radius: 25px;
          font-size: 1.125em;
          background-color: #FF6D46;
          width:187px;

          &:hover{
            background-color: #F45327;
          }
        }

        &.center{
          text-align: center;
        }
      }
    }
  }
  .buttons-login-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .button-margin {
    margin-bottom: 24px;
  }

  .title-login{
    font-size: 32px;
    line-height: 40px;
    font-weight: bold;
    text-align: center;
    display: block;
    margin: 88px 0 48px 0;
  }

  .custom-icon-color .icon.is-right {
    color: blue !important;
  }

  .forgot-password-wrapper{
    text-align: right;
  }
  .forgot-password{
    font-weight: bold;
    position: relative;
    display: inline-block;
    line-height: 1.1;
  }

  .forgot-password::before{
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #00CEC5;
  }

  .forgot-password:hover{
    color: #363636;
  }

  .forgot-password:hover::before{
    background-color: #363636;
  }

}
</style>
